import { Indices } from "../types";

export const add = (a: Indices, b: Indices): Indices => [
  Math.floor(a[0] + b[0]),
  Math.floor(a[1] + b[1]),
  Math.floor(a[2] + b[2]),
];
